import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import BeltIcon from '../BeltIcon';

const { FiCheck, FiRotateCcw, FiPlay } = FiIcons;

export default function TrainingCard({ technique, onDone, onReviewLater, onShowVideo }) {
  return (
    <motion.div 
      layout
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="glass-card-light rounded-3xl overflow-hidden border-white/20 w-full group mb-4"
    >
      <div className="p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-6">
        <div className="flex items-center gap-5 flex-1">
          <div className="flex-shrink-0">
            <BeltIcon type={technique.beltType} className="w-12 h-4 md:w-16 md:h-5 shadow-lg" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-3 mb-1">
              <h3 className="text-lg md:text-xl font-black text-white kr-text leading-tight uppercase tracking-tight truncate [text-shadow:_0_2px_4px_rgba(0,0,0,0.5)]">
                {technique.koreanName}
              </h3>
              <button 
                onClick={() => onShowVideo(technique)}
                className="md:hidden p-2 bg-white/10 hover:bg-red-600 rounded-xl text-white transition-all active:scale-90 flex-shrink-0"
              >
                <SafeIcon icon={FiPlay} className="w-4 h-4" />
              </button>
            </div>
            <p className="text-yellow-400 font-bold text-[10px] uppercase tracking-wider">
              {technique.spanishName}
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-stretch md:items-center gap-3 md:gap-4">
          <button 
            onClick={() => onShowVideo(technique)}
            className="hidden md:flex items-center justify-center p-3.5 bg-white/10 hover:bg-red-600 rounded-2xl text-white transition-all active:scale-90 group/vid"
          >
            <SafeIcon icon={FiPlay} className="w-5 h-5" />
          </button>
          
          <div className="grid grid-cols-2 md:flex gap-3">
            <button 
              onClick={() => onReviewLater(technique)}
              className="flex items-center justify-center gap-2 px-5 py-3.5 bg-white/10 hover:bg-white/20 rounded-2xl text-[10px] font-black uppercase tracking-widest text-white transition-all"
            >
              <SafeIcon icon={FiRotateCcw} />
              <span className="md:hidden lg:inline">Repasar</span>
            </button>
            <button 
              onClick={() => onDone(technique.id)}
              className="flex items-center justify-center gap-2 px-5 py-3.5 bg-green-600/30 hover:bg-green-600 text-white rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all shadow-lg shadow-green-600/10"
            >
              <SafeIcon icon={FiCheck} />
              <span className="md:hidden lg:inline">Logrado</span>
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
}